import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChartTooltipContainer, ContributionLine, ExpectedLine, ItemContent, ItemsContainer } from './styles';
import { Text } from '../../../Text';
export var ChartTooltip = function (_a) {
  var chartTooltipText = _a.chartTooltipText,
    pointValues = _a.pointValues;
  if (pointValues) {
    return _jsxs(ChartTooltipContainer, {
      children: [_jsx(Text, {
        el: "p",
        styleName: "bodySmall",
        variant: "secondary",
        children: "".concat(chartTooltipText.yearText, " ").concat(pointValues.selectedPointYear)
      }), _jsxs(ItemsContainer, {
        children: [_jsxs(ItemContent, {
          children: [_jsx(ExpectedLine, {}), _jsxs("div", {
            children: [_jsx(Text, {
              el: "p",
              styleName: "bodySmall",
              variant: "secondary",
              children: chartTooltipText.projectionText
            }), _jsx(Text, {
              el: "p",
              styleName: "bodySmall",
              variant: "secondary",
              children: _jsx("strong", {
                children: pointValues.pointProjectionYValue
              })
            })]
          })]
        }), _jsxs(ItemContent, {
          children: [_jsx(ContributionLine, {}), _jsxs("div", {
            children: [_jsx(Text, {
              el: "p",
              styleName: "bodySmall",
              variant: "secondary",
              children: chartTooltipText.contributionText
            }), _jsx(Text, {
              el: "p",
              styleName: "bodySmall",
              variant: "secondary",
              children: _jsx("strong", {
                children: pointValues.pointContributionYValue
              })
            })]
          })]
        })]
      })]
    });
  }
  return null;
};